import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { MediaMovieApiModel } from '@era/inroom-sdk';

import { MoviesActionsUnion, MoviesActionTypes } from './movies.actions';

export const inRoomMoviesFeatureKey = 'inroom-movies';

export type MoviesState = EntityState<MediaMovieApiModel>;

export function selectMovieId(movie: MediaMovieApiModel): string {
  return movie.Identifier ?? '';
}

export const adapter: EntityAdapter<MediaMovieApiModel> = createEntityAdapter<MediaMovieApiModel>({
  selectId: selectMovieId,
});

export const initialState: MoviesState = adapter.getInitialState({});

export function moviesReducer(state: MoviesState = initialState, action: MoviesActionsUnion): MoviesState {
  switch (action.type) {
    case MoviesActionTypes.LOAD_MOVIES:
      return adapter.setAll(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectMovieIds = selectIds;

export const selectMovieEntities = selectEntities;

export const selectAllMovies = selectAll;

export const selectMoviesTotal = selectTotal;
